import Cookies from "js-cookie";
import { ROLE_ALL } from "@/constant/permission";
import { useRouteStore } from "@/stores/index";

const EXPIRES: number = 1;
const TOKEN_KEY: string = "LJL_ADMIN_TOKEN";

export function getToken(): string | undefined {
  return Cookies.get(TOKEN_KEY);
}

export function isToken(): boolean {
  return !!Cookies.get(TOKEN_KEY);
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY);
}

// 退出登录清除信息
export function clearAllUserInfo() {
  removeToken();
  window.localStorage.removeItem("permissions");
  window.localStorage.removeItem("ljl_user_info");
}

// 设置token
export function setToken(token: string) {
  return Cookies.set(TOKEN_KEY, token, { expires: EXPIRES });
}

// 存储用户的权限信息
export function setPermissions(permission: string[]) {
  window.localStorage.setItem("permissions", JSON.stringify(permission));
}

// 获取用户权限信息，这里权限储存的是角色
export function getPermissions() {
  const permissions = window.localStorage.getItem("permissions");
  if (permissions) {
    return JSON.parse(permissions);
  }
  return [];
}

// 判断用户是否存在当前权限
export function hasPermission(
  permission: string | string[],
  whole: boolean = false
): boolean {
  const userInfo = useRouteStore();
  if (userInfo) {
    return userInfo.isPermission(permission, whole);
  }
  return false;
}

// 储存用户信息
export function setUserInfo(userInfo: { name: string }) {
  window.localStorage.setItem("ljl_user_info", JSON.stringify(userInfo));
}

// 课程的上下架权限
export function is_administrators_teacher(): boolean {
  return hasPermission([ROLE_ALL.Superadmin, ROLE_ALL.AdminTeacher]);
}

// 判断当前是否可以添加课程附件的权限
export function is_istrators_teacher(): boolean {
  return hasPermission([ROLE_ALL.Superadmin, ROLE_ALL.Teacher]);
}
